import { getItemFromCollection } from "directus/src/operations";
import { getUserFields } from "components/user/config";

export async function fetchPerformanceReview({ reviewId }) {
  try {
    const query = {
      fields: [
        "id",
        "quadrimester",
        "status",
        getUserFields("reviewee"),
        getUserFields("reviewer"),
        "*",
      ],
    };
    const response = await getItemFromCollection(
      "performance_review",
      reviewId,
      query
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
}
